import React from "react";
import {UserQuestionDto} from "../../../core/models/dtos/userQuestion.dto";
import {Constants} from "../../../core/utilities/constants";
import "./Question.scss";
import QuestionBody from "./QuestionBody/QuestionBody";
import QuestionHeader from "./QuestionHeader/QuestionHeader";
import QuestionOptions from "./QuestionOptions/QuestionOptions";

interface IProps {
  questionModel: QuestionModel;
  secondsLeft: number;
  selectedOptionId?: number;
  correctOptionId?: number;
}

export interface QuestionModel {
  level: number;
  userQuestion: UserQuestionDto;
  callbackOptionClick: (optionId: number) => void;
}

const Question = (props: IProps) => {

  const getTimeLeftAsPercent = (): number => {
    return (props.secondsLeft / Constants.questionDurationInSeconds) * 100;
  }

  return (
    <div
      key={props.questionModel.userQuestion.question.text}
      id="question"
    >
      <QuestionHeader
        level={props.questionModel.level}
      />
      <QuestionBody
        level={props.questionModel.level}
        question={props.questionModel.userQuestion.question.text}
        percent={getTimeLeftAsPercent()}
      />
      <QuestionOptions
        options={props.questionModel.userQuestion.question.options}
        selectedOptionId={props.selectedOptionId}
        correctOptionId={props.correctOptionId}
        callbackOptionClick={optionId => props.questionModel.callbackOptionClick(optionId)}
      />
    </div>
  );
}

export default Question;
